import ApiClient from './apiClient/ApiClient'
import type { WMSLayer } from '@popety-io/types'

const apiClient = new ApiClient()

export const wmsLayersService = {
  /**
   * Get all WMS layers
   * @returns Promise with array of WMS layers
   */
  async getAll(): Promise<WMSLayer[]> {
    try {
      const response = await apiClient.get('/map-wms-layers')

      if (response.errors) {
        throw new Error(
          response.errors[0]?.message || 'Failed to fetch WMS layers'
        )
      }

      // Handle different possible response formats
      if (Array.isArray(response.data)) {
        return response.data
      } else if (response.data?.data && Array.isArray(response.data.data)) {
        return response.data.data
      } else {
        throw new Error('Unexpected response format from WMS layers API')
      }
    } catch (error) {
      console.error('Error fetching WMS layers:', error)
      throw error
    }
  },

  /**
   * Get a single WMS layer by ID
   * @param id - The WMS layer ID
   * @returns Promise with the WMS layer
   */
  async getById(id: string): Promise<WMSLayer> {
    try {
      const response = await apiClient.get(`/map-wms-layers/${id}`)

      if (response.errors) {
        throw new Error(
          response.errors[0]?.message ||
            `Failed to fetch WMS layer with id ${id}`
        )
      }

      return response.data
    } catch (error) {
      console.error(`Error fetching WMS layer ${id}:`, error)
      throw error
    }
  },
}
